/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_None_AddableInputs */



/**
* | output |
* | --- |
* | "There is nothing to add. Ask an administrator to enable an integration for your organisation." |
*
* @param {My_Integrations_Wizard_None_AddableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_none_addable = /** @type {((inputs?: My_Integrations_Wizard_None_AddableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_None_AddableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es gibt nichts hinzuzufügen. Bitten Sie einen Administrator, eine Integration für Ihre Organisation zu aktivieren.")
	return /** @type {LocalizedString} */ ("There is nothing to add. Ask an administrator to enable an integration for your organisation.")
});